import React from 'react';
import { useAbandonedCheckoutRemindersSettings } from '@modules/Dashboard/pages/Settings/pages/Checkout/hooks/useAbandonedCheckoutRemindersSettings';
import { AppsKlaviyoView } from './AppsKlaviyoView';
import { useKlaviyo } from './hooks/useKlaviyo';
export const AppsKlaviyo = () => {
    const { klaviyo } = useKlaviyo();
    const { abandonedCheckoutRemindersSettings } = useAbandonedCheckoutRemindersSettings();
    const isOff = abandonedCheckoutRemindersSettings.initialValues.abandonedCheckoutEmailFrequency === 'off';
    return React.createElement(AppsKlaviyoView, { connectBar: klaviyo.connectBar, abandonedCheckoutIsOff: isOff });
};
